/**
 * Theme toggle button — sun/moon icons for light/dark mode.
 * Both icons always in DOM; CSS shows/hides via .dark class
 * to avoid flash on hydration.
 */

import { useTheme } from "@/lib/theme";
import { Moon, Sun } from "@phosphor-icons/react";

export function ThemeToggle() {
  const [, , setTheme] = useTheme();

  return (
    <button
      onClick={() => {
        const isDark = document.documentElement.classList.contains("dark");
        setTheme(isDark ? "light" : "dark");
      }}
      className="group inline-flex items-center justify-center h-11 w-11 lg:h-11 lg:w-11 rounded-md hover:bg-accent transition-colors"
      aria-label="Toggle theme"
    >
      {/* Hover tints: indigo for the moon (about-to-go-dark) and
          amber for the sun (about-to-go-light). Matches each glyph's
          natural colour association and signals the target mode the
          click will switch to. */}
      <Moon
        className="h-5 w-5 text-foreground block dark:hidden group-hover:text-indigo-500 transition-colors"
        weight="duotone"
      />
      <Sun
        className="h-5 w-5 text-foreground hidden dark:block group-hover:text-amber-400 transition-colors"
        weight="duotone"
      />
    </button>
  );
}
